import { useLinkStories } from 'components/minute/sidebar/interactivity/InteractivitySidebar/useLinkStories';
import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { StorySearchInput } from 'elements/minute/sidebar/sidebarComponents/complex/StorySearchInput';
import { DetailQuery_moment } from 'graphql/query/__generated__/DetailQuery';
import { useDetailCRUD } from 'hooks/detail/useDetailCRUD';
import { useWorldMarker } from 'hooks/marker/useWorldMarker';
import { EShadows } from 'libs/styles/styling';
import _ from 'lodash';
import { useContext, useState } from 'react';
import { CtxDetail } from 'session/ctxDetail';
import { CtxEdit } from 'session/ctxEdit';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';
import { v4 as uuid } from 'uuid';

interface Props {
    className?: string;
}

export const CreateInteractivity = (props: Props): JSX.Element => {
    const ctxDetail = useContext(CtxDetail);
    const ctxEdit = useContext(CtxEdit);
    const ctxView = useContext(CtxView);
    const detailCRUD = useDetailCRUD(ctxDetail.map?.worldMapId);
    const [loading, setLoading] = useState(false);
    const worldMarker = useWorldMarker();
    const selectedMarker = worldMarker.getSingleMarkerIfOne();
    const linkStories = useLinkStories();

    function updateMarkerWithStory(story: DetailQuery_moment) {
        //merge ctxView.allDetails with new detail, if not there
        const index = ctxView.allDetails.findIndex((e) => e.storyId === story?.storyId);
        const details = _.clone(ctxView.allDetails) ?? [];
        if (index === -1) {
            details.push(story);
        }

        linkStories.link(details, ctxDetail.map?.worldMapId, selectedMarker.id, [story?.storyId]);

        ctxEdit.updateWorldMarker(selectedMarker.id, {
            storyIds: [story.storyId]
        });

        setLoading(false);
    }

    async function link(storyId: string) {
        ctxDetail.reset();
        setLoading(true);

        const detail = await detailCRUD.readDetail(storyId);
        updateMarkerWithStory(detail.data.moment);
    }

    async function create() {
        ctxDetail.reset();
        setLoading(true);

        const detail = await detailCRUD.createDetail({
            storyId: uuid(),
            cards: [],
            story: {
                worldMapId: ctxDetail.map?.worldMapId,
                header: {
                    title: '',
                    text: ''
                }
            }
        });

        updateMarkerWithStory(detail.data.createWorldStory);
    }

    return (
        <S_CreateInteractivity className={props.className}>
            <S_Mid>
                <S_Message type="info">{Localization.INTERACTIVITY_PROMPT}</S_Message>
                <S_StorySearchInput
                    worldMapId={ctxDetail.map?.worldMapId}
                    excludeExternalStoryIds
                    onStorySelected={(storyId) => {
                        link(storyId);
                    }}
                />

                <S_TextOR>{Localization.OR}</S_TextOR>

                <S_WebButtonSmaller
                    shadow={EShadows.LIGHT}
                    type="primary"
                    text={Localization.CREATE_INTERACTIVITY_ACTION}
                    onClick={() => {
                        create();
                    }}
                    loading={loading}
                    disabled={loading}
                />
            </S_Mid>
        </S_CreateInteractivity>
    );
};

const S_CreateInteractivity = styled.div``;

const S_Mid = styled.div`
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const S_Message = styled(Message)`
    margin: 0 0 15px 0;
`;

const S_StorySearchInput = styled(StorySearchInput)`
    margin-bottom: 20px;
    width: 340px;
`;

const S_TextOR = styled.div`
    margin-bottom: 20px;
`;
